/**
 * Ported from the Slate-era webpack bundle (src/scripts/templates/page.faqs.js).
 * Requires priority-nav-scroller.js (window.PriorityNavScroller) loaded first.
 */
(function () {
var PriorityNavScroller = window.PriorityNavScroller;

document.addEventListener('DOMContentLoaded', () => {
  //$('body').scrollspy({ target: '#faqs-tabs' });

  // priorityNavScroller
  // ---------
  const navScrollers = document.querySelectorAll('.nav-scroller');

  if (navScrollers.length) {
    const priorityNavScrollerDefault = PriorityNavScroller({
      selector: '.nav-scroller',
      navSelector: '.nav-scroller-nav',
      contentSelector: '.nav-scroller-content',
      itemSelector: '.nav-scroller-item',
      buttonLeftSelector: '.nav-scroller-btn--left',
      buttonRightSelector: '.nav-scroller-btn--right',
      scrollStep: 75
    });

    navScrollers.forEach((currentValue, currentIndex) => {
      PriorityNavScroller({
        selector: currentValue
      });
    });
  }
});

})();
